import React, { FC } from 'react';
import { ProjectDpFormProps } from './ProjectDPFormProps';
import { Stack } from '@mui/material';
import Text from '@ingka/text';
import useTranslation from '../../hooks/useTranslation';
import DecisionPointRow from '../DecisionPointRow';

const ProjectDpForm: FC<ProjectDpFormProps> = ({ decisionPoints }) => {
  const t = useTranslation();
  return decisionPoints?.length ? (
    <Stack mt={3} spacing={3}>
      <Text textStyle="Body.M" style={{ color: 'black' }}>
        <b>{t('tabs.dp')}</b>
      </Text>
      {[...decisionPoints]
        .sort(
          (a, b) =>
            Number(a.decisionPoint.slice(2, 4)) -
            Number(b.decisionPoint.slice(2, 4)),
        )
        .map((dp, index) => (
          <DecisionPointRow decisionPoint={dp} key={index} />
        ))}
    </Stack>
  ) : null;
};

export default ProjectDpForm;
